import { useState } from "react";
import DescriptionIcon from "@mui/icons-material/Description";
import { Button, Menu, MenuItem } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

const ExtractBtn = ({ typeRelatorio, loading }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOptions = (event) => {
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const styleButton = {
    cursor: loading ? "wait" : "pointer",
    border: loading ? "1px solid #d4d4d4" : "1px solid #18316E",
    borderRadius: "20px",
    color: loading ? "#d4d4d4" : "#18316E",
    "&:hover": {
      backgroundColor: "#d0daf5",
    },
  };

  const styleMenuItem = {
    display: "flex",
    gap: "5px",
    cursor: loading ? "wait" : "pointer",
  };

  const styleText = {
    color: loading ? "#d4d4d4" : "#18316e",
  };

  return (
    <div>
      <Button
        startIcon={<DescriptionIcon />}
        sx={styleButton}
        onClick={handleOptions}
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        fullWidth
      >
        EXTRAIR
      </Button>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleOptions}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={() => !loading && typeRelatorio("PDF")} sx={styleMenuItem}>
          <PictureAsPdfIcon sx={styleText} />
          <span style={styleText}>PDF</span>
        </MenuItem>
        <MenuItem onClick={() => !loading && typeRelatorio("csv")} sx={styleMenuItem}>
          <TableChartOutlinedIcon sx={styleText} />
          <span style={styleText}>CSV</span>
        </MenuItem>
        <MenuItem onClick={() => !loading && typeRelatorio("AMBOS")} sx={styleMenuItem}>
          <FileDownloadOutlinedIcon sx={styleText} />
          <span style={styleText}>Ambos</span>
        </MenuItem>
      </Menu>
    </div>
  );
};
export default ExtractBtn;
